import { AlertType } from 'interfaces';
import { Dispatch } from 'redux';
import { setAlert, showAlert } from 'redux/modules/Alert/alert';

export const showSimpleSuccessAlert = (
  dispatch: Dispatch,
  title: string,
  bodyText: string,
) => {
  dispatch(
    setAlert({
      type: AlertType.success,
      title,
      bodyText,
    }),
  );
  dispatch(showAlert());
};
